// import { AsyncStorage } from 'react-native'
import { createStore, applyMiddleware, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { reducer as cart } from './Cart/Cart'
import { reducer as products } from './Products/Products'
import { reducer as offers } from './Offers/Offers'
import { reducer as services } from './Services/Services'
import { reducer as shop } from './Shop/Shop'
import { reducer as ui } from './UI/UI'
import { reducer as userGuest } from './User/Guest'

const rootReducer = combineReducers({
	cart,
	products,
	offers,
	services,
	shop,
	ui,
	userGuest,
})

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['cart', 'userGuest']
}

const pReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(pReducer, composeWithDevTools(applyMiddleware(thunkMiddleware)))
export const persistor = persistStore(store)
